"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeartControlPanel = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const bridge_1 = require("@completeanatomy/bridge");
const hooks_1 = require("../../hooks");
const molecules_1 = require("../../molecules");
function HeartControlPanel({ className }) {
    const panelInfo = (0, hooks_1.useBeatingHeartState)();
    const slider = panelInfo === null || panelInfo === void 0 ? void 0 : panelInfo.slider;
    const isEcgMode = !!(slider === null || slider === void 0 ? void 0 : slider.isEcgVisible);
    const [isHintVisible, setHintVisible] = (0, react_1.useState)(false);
    const bridge = (0, bridge_1.useBridge)();
    /*
     * @TODO - return double click event handler when this logic is removed from the native
     *   Was removed in 3d4medical-ca-ui#99
     */
    const showHint = () => setHintVisible(true);
    const hideHint = () => setHintVisible(false);
    const onSwipe = (isSwipeUp) => {
        if (isSwipeUp && !isEcgMode) {
            bridge === null || bridge === void 0 ? void 0 : bridge.setBeatingHeartEcgMode();
        }
        if (!isSwipeUp && isEcgMode) {
            bridge === null || bridge === void 0 ? void 0 : bridge.setBeatingHeartSliderMode();
        }
    };
    const onChangeBpm = (increase) => () => {
        increase
            ? bridge === null || bridge === void 0 ? void 0 : bridge.beatingHeartIncreaseBpmValueAction()
            : bridge === null || bridge === void 0 ? void 0 : bridge.beatingHeartDecreaseBpmValueAction();
    };
    const onPlayToggle = () => {
        (panelInfo === null || panelInfo === void 0 ? void 0 : panelInfo.isPaused)
            ? bridge === null || bridge === void 0 ? void 0 : bridge.beatingHeartPlayAction()
            : bridge === null || bridge === void 0 ? void 0 : bridge.beatingHeartPauseAction();
    };
    return ((0, jsx_runtime_1.jsxs)(ControlPanel, { className: className, "data-e2e": 'HeartControlPanel_ControlPanel', children: [(0, jsx_runtime_1.jsxs)("div", { onMouseDown: showHint, onMouseUp: hideHint, "data-e2e": 'HeartControlPanel_div', children: [isHintVisible && !isEcgMode && (0, jsx_runtime_1.jsx)(StyledECGHint, { "data-e2e": 'HeartControlPanel_StyledECGHint' }), (0, jsx_runtime_1.jsx)(molecules_1.Slider, { isPlaying: !(panelInfo === null || panelInfo === void 0 ? void 0 : panelInfo.isPaused), value: slider === null || slider === void 0 ? void 0 : slider.value, bpm: slider === null || slider === void 0 ? void 0 : slider.bpmValue, onHideHint: hideHint, onSwipe: onSwipe, ecgMode: isEcgMode, "data-e2e": 'HeartControlPanel_Slider' })] }), (0, jsx_runtime_1.jsxs)(BottomContainer, { "data-e2e": 'HeartControlPanel_BottomContainer', children: [(0, jsx_runtime_1.jsx)("div", { "data-e2e": 'HeartControlPanel_div', children: isEcgMode && !isHintVisible ? ((0, jsx_runtime_1.jsx)(molecules_1.BPMControl, { bpm: slider === null || slider === void 0 ? void 0 : slider.bpmValue, isIncreaseBPMAvailable: slider === null || slider === void 0 ? void 0 : slider.isIncreaseBPMAvailable, isDecreaseBPMAvailable: slider === null || slider === void 0 ? void 0 : slider.isDecreaseBPMAvailable, onIncreaseBPM: onChangeBpm(true), onDecreaseBPM: onChangeBpm(false), "data-e2e": 'HeartControlPanel_BPMControl' })) : ((0, jsx_runtime_1.jsx)(Placeholder, { "data-e2e": 'HeartControlPanel_Placeholder', children: isHintVisible && isEcgMode && (0, jsx_runtime_1.jsx)(StyledSliderHint, { "data-e2e": 'HeartControlPanel_StyledSliderHint' }) })) }), (0, jsx_runtime_1.jsx)(RightBottomContainer, { "data-e2e": 'HeartControlPanel_RightBottomContainer', children: !isHintVisible && ((0, jsx_runtime_1.jsx)(molecules_1.PlayButton, { isPlaying: !(panelInfo === null || panelInfo === void 0 ? void 0 : panelInfo.isPaused), onToggle: onPlayToggle, "data-e2e": 'HeartControlPanel_PlayButton' })) })] })] }));
}
exports.HeartControlPanel = HeartControlPanel;
const ControlPanel = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
`;
const BottomContainer = styled_components_1.default.div `
  display: flex;
`;
const RightBottomContainer = styled_components_1.default.div `
  width: 71px;
`;
const StyledSliderHint = (0, styled_components_1.default)(molecules_1.SliderHint) `
  height: 61px;
  margin: auto;

  padding-left: 25px;
`;
const StyledECGHint = (0, styled_components_1.default)(molecules_1.ECGHint) `
  width: 100px;
  height: 61px;
  margin: auto;

  transform: translate(-40px, 130px);
`;
const Placeholder = styled_components_1.default.div `
  width: 195px;
  height: 62px;
`;
